import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const LocalSEOGuide = () => {
  const relatedBlogs = [
    {
      id: 2,
      title: 'Top 10 Social Media Marketing Strategies for Doctors in 2026',
      image: '/images/Blog2.png',
      date: 'January 28, 2026'
    },
    {
      id: 3,
      title: 'The Complete Guide to Google Ads for Healthcare Providers',
      image: '/images/Blog3.png',
      date: 'January 20, 2026'
    },
    {
      id: 4,
      title: 'Patient Acquisition Through Digital Marketing: A Complete Guide',
      image: '/images/Blog4.png',
      date: 'January 15, 2026'
    }
  ];

  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-4 sm:px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8"
          >
            Local SEO Guide for Medical Practices
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Home
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <Link 
              to="/blog" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Blog
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <span className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold text-sm sm:text-base">
              Local SEO Guide
            </span>
          </motion.div>
        </div>
      </section>

      {/* SECTION 1: TWO-COLUMN WITH SIDEBAR */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <div className="grid lg:grid-cols-12 gap-6 lg:gap-8">
            
            {/* LEFT SIDE - Intro Content */}
            <div className="lg:col-span-8">
              
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="mb-8"
              >
                <img 
                  src="/images/Blog4.png" 
                  alt="Local SEO for Medical Practices"
                  className="w-full rounded-2xl"
                />
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#19354a] mb-6"
              >
                How to Optimize Your Medical Practice Website for Local SEO in 2026
              </motion.h1>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="flex flex-wrap items-center gap-4 text-sm text-[#19354a] mb-8 pb-6 border-b-2 border-gray-200"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                  </svg>
                  <span>Docmize Team</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Published : February 3, 2026</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <span>Last Updated : February 3, 2026</span>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                  In 2026, local SEO remains the cornerstone of digital visibility for medical practices. With patients increasingly turning to search engines to find nearby healthcare providers, optimizing your medical practice website for local search has never been more critical. Studies show that 77% of patients use search engines before booking appointments, making local SEO optimization essential for practice growth and patient acquisition.
                </p>

                <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
                  This comprehensive guide explores proven strategies that help medical practices dominate local search results, attract more qualified patients, and build a strong online presence in their service areas. From Google Business Profile optimization to schema markup implementation, we'll cover everything you need to know about local SEO for healthcare providers in 2026.
                </p>
              </motion.div>

            </div>

            {/* RIGHT SIDE - Sidebar */}
            <motion.aside 
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="lg:col-span-4"
            >
              <div className="sticky top-24">
                
                <div className="bg-white rounded-2xl border-2 border-[#19354a] p-6 mb-6">
                  <h3 className="text-xl font-bold text-[#19354a] mb-6 pb-4 border-b-2 border-gray-200">
                    Categories
                  </h3>
                  <div className="space-y-2">
                    {['Web Development', 'SEO', 'Social Media', 'Web Design', 'Online Reputation Management', 'Digital Marketing', 'Video Marketing', 'Paid Advertising', 'App Development'].map((category, index) => (
                      <Link
                        key={index}
                        to="/blog"
                        className="w-full text-left px-4 py-3 rounded-lg font-medium transition-all bg-gray-50 text-gray-700 hover:bg-[#19354a] hover:text-white block"
                      >
                        <div className="flex items-center justify-between">
                          <span>{category}</span>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>

                <div className="bg-gradient-to-br from-[#19354a] to-[#0f2133] rounded-2xl p-6 text-white">
                  <h3 className="text-xl font-bold mb-4">
                    Need Help with Local SEO?
                  </h3>
                  <p className="text-white/80 mb-6 text-sm leading-relaxed">
                    Get expert healthcare local SEO strategies tailored to your practice needs.
                  </p>
                  <Link 
                    to="/contact"
                    className="block w-full text-center px-6 py-3 bg-[#39a5d3] text-white rounded-lg font-semibold hover:bg-white hover:text-[#19354a] transition-all"
                  >
                    Get Free Consultation
                  </Link>
                </div>

              </div>
            </motion.aside>

          </div>
        </div>
      </section>

      {/* SECTION 2: FULL WIDTH CONTENT */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Understanding Local SEO for Medical Practices in 2026
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Local SEO for medical practices focuses on optimizing your online presence to appear in location-based searches. In 2026, search algorithms prioritize proximity, relevance, and prominence when ranking healthcare providers. This means your practice needs to demonstrate expertise, authority, and trustworthiness (E-A-T) while maintaining strong local signals across all digital platforms.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              The healthcare industry faces unique SEO challenges, including HIPAA compliance, medical advertising regulations, and high competition for local keywords. Successful practices combine technical optimization with content marketing, reputation management, and patient engagement strategies to achieve sustainable visibility in local search results.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Optimizing Your Google Business Profile
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Your Google Business Profile (formerly Google My Business) serves as the foundation of your local SEO strategy. Complete optimization includes accurate NAP (Name, Address, Phone) information, comprehensive service descriptions, high-quality photos, and regular posts about practice updates, health tips, and patient success stories.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              In 2026, Google prioritizes profiles with complete information, active engagement, and consistent positive reviews. Medical practices should add all relevant categories, specify service areas, upload professional photos of facilities and staff, and maintain an active posting schedule. Additionally, enable messaging features and respond promptly to patient inquiries through your profile.
            </p>

            <h3 className="text-xl sm:text-2xl font-bold text-[#19354a] mb-4 mt-6">
              Key Google Business Profile Strategies
            </h3>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Successful profile optimization requires consistent attention to several critical elements:
            </p>

            <ul className="list-disc list-inside text-gray-900 text-base leading-relaxed mb-6 space-y-2 ml-4 text-justify">
              <li>Complete all profile sections with accurate, detailed information</li>
              <li>Upload high-quality photos of your practice, team, and facilities</li>
              <li>Respond to all patient reviews within 24-48 hours</li>
              <li>Post regular updates about services, health tips, and practice news</li>
              <li>Add all relevant medical specialties and service categories</li>
              <li>Enable appointment booking directly through your profile</li>
            </ul>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Website Technical Optimization for Local Search
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Technical SEO forms the backbone of your local search visibility. Healthcare websites must load quickly, display correctly on mobile devices, and include proper schema markup to help search engines understand your content. In 2026, Core Web Vitals remain crucial ranking factors, with mobile-first indexing determining how Google evaluates your site.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Implement LocalBusiness schema markup to provide search engines with structured data about your practice location, services, and contact information. Add MedicalOrganization schema for specialty-specific details. Ensure your website uses HTTPS encryption, loads within 2 seconds, and provides an excellent user experience across all devices.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Creating Location-Specific Content
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Content marketing drives local SEO success by demonstrating expertise and relevance to your target geographic area. Create comprehensive service pages for each specialty, location-specific landing pages for multi-location practices, and informative blog content addressing common patient concerns in your area.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Incorporate local keywords naturally throughout your content, including city names, neighborhoods, and regional terms patients use when searching for healthcare services. Develop resource pages about health topics relevant to your community, participate in local health events, and create content that establishes your practice as a trusted local healthcare authority.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Building Local Citations and Backlinks
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Local citations—mentions of your practice name, address, and phone number across the web—signal credibility to search engines. List your practice on relevant healthcare directories, medical review sites, and local business platforms. Maintain consistent NAP information across all listings to avoid confusion and ranking penalties.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Acquire high-quality backlinks from local organizations, medical associations, health blogs, and community websites. Participate in local health fairs, sponsor community events, and contribute expert commentary to local news outlets. These activities generate valuable backlinks while establishing your practice as a community healthcare leader.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Managing Online Reviews and Reputation
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Patient reviews significantly impact local search rankings and patient decision-making. Actively encourage satisfied patients to leave reviews on Google, Healthgrades, Vitals, and other relevant platforms. Respond professionally to all reviews—both positive and negative—demonstrating your commitment to patient satisfaction and continuous improvement.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Implement a systematic review generation strategy that respects HIPAA regulations and patient privacy. Use automated follow-up emails, text message requests, and in-office signage to remind patients about leaving feedback. Monitor your online reputation closely and address negative reviews promptly with empathy and professionalism.
            </p>

            <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-4 mt-8">
              Measuring and Improving Local SEO Performance
            </h2>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Track key performance indicators to measure your local SEO success and identify improvement opportunities. Monitor local search rankings, organic traffic from local searches, Google Business Profile insights, phone calls from search, appointment bookings, and conversion rates. Use tools like Google Analytics, Google Search Console, and specialized healthcare SEO platforms to gather comprehensive data.
            </p>

            <p className="text-gray-900 text-base leading-relaxed mb-6 text-justify">
              Regularly audit your local SEO performance, analyze competitor strategies, and adapt your approach based on data-driven insights. Local SEO requires ongoing optimization—search algorithms evolve, competitors adjust their strategies, and patient search behaviors change. Commit to continuous improvement and maintain consistent optimization efforts for long-term success.
            </p>

            {/* FAQ SECTION */}
            <div className="mt-12 mb-12">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#19354a] mb-8 text-center">
                Frequently Asked Questions (FAQs)
              </h2>

              <div className="space-y-4">
                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How long does it take to see results from local SEO?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Most medical practices begin seeing improvements within 3-6 months of implementing comprehensive local SEO strategies. However, significant ranking improvements and sustained traffic growth typically require 6-12 months of consistent optimization efforts.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      What are the most important local SEO ranking factors?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    The primary ranking factors include Google Business Profile optimization, online reviews and ratings, local citations consistency, website technical optimization, mobile responsiveness, and location-specific content quality. Proximity to the searcher also plays a crucial role.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How do I handle negative reviews professionally?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Respond promptly and professionally to negative reviews. Acknowledge the patient's concerns, apologize for their experience, and offer to discuss the matter privately. Never violate HIPAA by discussing specific medical details publicly. Use negative feedback as opportunities to demonstrate excellent customer service.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      Should multi-location practices have separate websites?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    While separate websites can work, most multi-location practices achieve better results with location-specific landing pages on a single authoritative domain. Create unique, comprehensive content for each location while maintaining unified branding and centralized authority.
                  </div>
                </details>

                <details className="group bg-white rounded-lg border-2 border-gray-200 overflow-hidden">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none hover:bg-gray-50 transition-colors">
                    <h3 className="text-lg font-bold text-[#19354a] pr-4">
                      How can Docmize help with my practice's local SEO?
                    </h3>
                    <span className="text-[#39a5d3] text-2xl font-light group-open:hidden">+</span>
                    <span className="text-[#39a5d3] text-2xl font-light hidden group-open:block">−</span>
                  </summary>
                  <div className="px-6 pb-6 text-gray-900 leading-relaxed border-t border-gray-200 pt-4 text-justify">
                    Docmize specializes in healthcare local SEO with proven strategies for medical practices. We handle complete Google Business Profile optimization, website technical improvements, content creation, citation building, review management, and ongoing performance tracking. Our healthcare-focused approach ensures HIPAA compliance and industry-specific best practices.
                  </div>
                </details>
              </div>
            </div>

          </motion.div>
        </div>
      </section>

      {/* RELATED BLOGS SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl font-bold text-[#19354a] mb-8"
          >
            Related Blog
          </motion.h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {relatedBlogs.map((blog, index) => (
              <motion.article
                key={blog.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={blog.image} 
                    alt={blog.title}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-[#19354a] mb-3 line-clamp-2">
                    {blog.title}
                  </h3>
                  <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                    </svg>
                    <span>{blog.date}</span>
                  </div>
                  <Link 
                    to={`/blog/${blog.id}`}
                    className="inline-flex items-center gap-2 text-[#39a5d3] font-semibold hover:gap-3 transition-all"
                  >
                    Read More
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LocalSEOGuide;